import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import logo from 'assets/icons/logo-crediautos.svg';
import 'assets/scss/splash-screen.scss';
import Header from 'components/header/Header';
import { themeOptions } from 'config/themeOptions';
import { DocumentUploadContainer } from 'container/DocumentUploadContainer';
import FinancialAdvisoryContainer from 'container/FinancialAdvisoryContainer';
import { HomeContainer } from 'container/HomeContainer';
import { LoanFromMarketplaceContainer } from 'container/LoanFromMarketplaceContainer';
import { LoanSelfCareMultiFormContainer } from 'container/LoanSelfServicesMultiFormContainer';
import { LoanSimpleFormContainer } from 'container/LoanSimpleFormContainer';
import { MainContainer } from 'container/MainContainer';
import { NewSimulationContainer } from 'container/NewSimulationContainer';
import { ContactContainer } from 'container/ContactContainer';
import { PortabilidadContainer } from 'container/PortabilidadContainer';
import { RefinancingContainer } from 'container/RefinancingContainer';
import { ResponseContainer } from 'container/ResponseContainer';
import { SimulationContainer } from 'container/SimulationContainer';
import { LoandingContext } from 'context/LoandingContext';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { QuotationSimpleFormContainer } from 'container/QuotationSimpleFormContainer';
import { CreditLocationMultiFormContainer } from './container/CreditLiquidationMultiFormContainer';

const theme = createMuiTheme(themeOptions);

function App() {
	const [loading, setLoading] = React.useState(false);
	const [zIndex, setZIndex] = React.useState(9999);

	console.log('changes are here');

	useEffect(() => {
		if (loading === true) {
			setZIndex(9999);
		} else {
			setTimeout(() => {
				setZIndex(-1);
			}, 1000);
		}
	}, [loading]);

	return (
		<ThemeProvider theme={theme}>
			<LoandingContext.Provider value={{ setLoading }}>
				<div
					className={`splash-screen ${loading ? '--' : 'splash-close'}`}
					style={{
						zIndex: zIndex,
					}}
				>
					<img src={logo} alt="logo" width="200" />
				</div>

				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
					}}
				>
					<Header />
					<Router>
						<Switch>
							<Route path="/" exact>
								<HomeContainer />
							</Route>
							<Route component={FinancialAdvisoryContainer} path="/ayuda-financiera/:page" exact />
							<Route component={FinancialAdvisoryContainer} path="/ayuda-financiera/" exact />

							<Route path="/auto-atencion/" exact>
								<MainContainer children={<LoanSelfCareMultiFormContainer />} />
							</Route>
							<Route path="/credit-liquidation/" exact>
								<MainContainer children={<CreditLocationMultiFormContainer />} />
							</Route>
							<Route path="/credito-automotriz-simple" exact>
								<MainContainer children={<LoanSimpleFormContainer />} />
							</Route>
							<Route path="/cotizacion-simple" exact>
								<MainContainer children={<QuotationSimpleFormContainer />} />
							</Route>
							<Route path="/credito-automotriz-marketplace" exact>
								<MainContainer children={<LoanFromMarketplaceContainer />} />
							</Route>
							{/* <Route path="/credito-moto" exact>
								<MainContainer children={<LoanMotoContainer />} />
							</Route>
							<Route path="/credito-prendario-autofinanciamiento" exact>
								<MainContainer children={<LoanAutoFinanciamiento />} />
							</Route> */}
							<Route path="/portabilidad/" exact>
								<MainContainer children={<PortabilidadContainer />} />
							</Route>
							<Route path="/simulacion" exact>
								<MainContainer children={<SimulationContainer />} />
							</Route>
							<Route path="/subida-archivos/:crmId" exact>
								<MainContainer children={<DocumentUploadContainer />} />
							</Route>
							<Route path="/nueva-simulacion" exact>
								<MainContainer children={<NewSimulationContainer />} />
							</Route>
							<Route path="/contactanos" exact>
								<MainContainer children={<ContactContainer />} />
							</Route>
							<Route path="/refinancia-tu-credito" exact>
								<MainContainer children={<RefinancingContainer />} />
							</Route>
							<Route path="/respuesta/:response/:dataLayer" exact>
								<MainContainer children={<ResponseContainer />} isResponse={true} />
							</Route>
						</Switch>
					</Router>
				</div>
			</LoandingContext.Provider>
		</ThemeProvider>
	);
}

export default App;
